<template>
    <div class="club" @click="goClub">{{club}}</div>
</template>


<script>

import router from '@/router';

export default {
  components: { },
  props: { club: String, url: Object },
  data () {
    return {
    }
  },
  computed: {

  },
  methods: {
      goClub(){
          this.$emit( 'clicklink' )

          router.push( this.url );
      }
  },
  created() {
  },

  filters: {
	  	
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
    .club {
        @include font-size(16px);
        width: fit-content;

        padding-left: 30px;

        &::before {
            content: "";
            position: absolute;
            background-image: url( '/img/club.svg' );
            background-size: 20px;
            background-position: left center;
            background-repeat: no-repeat;
            width: 20px;
            height: 20px;
            left: 0;
            top: 0;
        }

        &::after {
            content: "";
            position: absolute;
            background-image: url(/img/goto.svg);
            background-repeat: no-repeat;
            margin-left: 20px;
            width: 20px;
            height: 20px;
            background-size: 20px;
            background-position: top center;
        }
    }
</style>